/* src/app/shared/components/ag-drop-down/ag-right-checkmark-box/ag-right-checkmark-box.component.scss */
.additional-charges-form {
  background-color: #ffffff;
  width: 95%;
  height: 45px;
  padding-inline-start: 8px;
  padding-top: 3px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 24px;
  padding-left: 15px;
  margin-bottom: 0;
  border-radius: 16px;
  display: flex;
  align-items: center;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-standard {
  padding-left: 0px;
  position: inherit;
  z-index: 2;
  max-height: 100%;
  height: fit-content;
  width: 100%;
  min-width: 82px;
  border-radius: 12px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #61566e;
  background-color: #ffffff;
  overflow: hidden;
}
.container-fixed {
  padding-left: 0px;
  padding-right: 8px;
  position: fixed;
  z-index: 1010;
  max-height: 100%;
  height: fit-content;
  border-radius: 8px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #c8c7cc;
  background-color: #ffffff;
}
.header {
  padding-left: 16px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #8f8e95;
}
.items-container {
  width: 100%;
}
.hovering-item {
  width: 100%;
}
.hovering-item:hover,
.hovering-item:hover .item {
  background-color: #f2f2f2;
}
.item {
  width: 100%;
  height: fit-content;
  min-height: 33px;
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  color: #222222;
}
.disabled-item {
  width: 100%;
  height: fit-content;
  min-height: 33px;
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  color: #a6a6a6;
  cursor: not-allowed;
}
label {
  margin-bottom: 0 !important;
}
.item-text {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}
.item-text-medium {
  font-family: "Poppins-Medium";
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}
.checkbox {
  padding-right: 12px;
  pointer-events: none;
  cursor: pointer;
}
.item-text-left {
  position: relative;
  vertical-align: sub;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-wrap: wrap;
}
.item-text-bold {
  position: relative;
  vertical-align: sub;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-wrap: wrap;
}
.select-all-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 84px;
}
.clickable {
  background: none;
  border: none;
  padding: 0;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  color: #4f356e;
  text-decoration: underline;
}
.not-clickable {
  background: none;
  border: none;
  padding: 0;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  color: #a6a6a6;
  text-decoration: underline;
}
.spacer {
  padding-bottom: 8px;
}
.top-bottom-padding {
  padding-bottom: 8px;
  height: fit-content;
  display: block;
  overflow-y: scroll;
  overflow-x: hidden;
}
.top-bottom-padding::-webkit-scrollbar-thumb {
  background-color: #a6a6a6;
  border-radius: 100px;
  width: 8px;
  height: 10px;
}
.top-bottom-padding::-webkit-scrollbar-track {
  background-color: #f2f2f2;
}
.form-div {
  position: relative;
  width: 100%;
  padding: 12px 12px 0px 12px;
}
.search-bar {
  display: flex;
  flex-direction: row-reverse;
  gap: 12px;
  padding: 12px 8px 12px 8px;
  background-color: #f2f2f2;
  border-radius: 12px;
  width: 100%;
}
.form-img {
  height: 24px;
  width: 24px;
  opacity: 0.5;
}
.code-changeable-img {
  position: absolute;
  right: 8px;
  top: 15px;
  transform: rotate(-180deg);
}
.search-bar-input {
  width: 95%;
  float: right;
  font-size: 14px;
  border: none;
  background-color: #f2f2f2;
  overflow: hidden;
  text-overflow: ellipsis;
}
input:focus {
  outline: none;
}
:-ms-input-placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #a6a6a6;
}
::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #a6a6a6;
}
.no-result-text {
  color: #a6a6a6;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  font-family: "Poppins-Regular";
}
input:focus {
  outline: none;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  margin-bottom: 12px;
  margin-top: 12px;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 3px;
  padding: 16px 13px;
}
.radio-button {
  accent-color: #222222;
}
/*# sourceMappingURL=ag-right-checkmark-box.component.css.map */
